import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { AnimatePresence } from 'framer-motion'

import { Portal } from '../portal'
import {
  SidebarAside,
  SidebarBackdrop,
  SidebarCloseButton,
  SidebarContainer,
  SidebarContent,
} from './SlidingSidebar.styles'

import type { ReactNode } from 'react'

type Props = {
  open: boolean
  backgroundColor: string
  width: number
  children?: ReactNode
  closeButtonVisible?: boolean
  onDismiss?: () => void
}

const childrenVariants = {
  closed: {
    opacity: 0,
  },
  open: {
    opacity: 1,
  },
}

export const SlidingSidebar = ({
  open,
  backgroundColor,
  width,
  children,
  closeButtonVisible = true,
  onDismiss,
}: Props) => {
  return (
    <Portal wrapperId='sliding-filter-sidebar'>
      <SidebarContainer>
        <AnimatePresence>
          {open && (
            <>
              <SidebarBackdrop
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                onClick={onDismiss}
              />
              <SidebarAside
                backgroundColor={backgroundColor}
                initial={{ x: width }}
                animate={{
                  x: -0,
                }}
                exit={{ x: width }}
              >
                <SidebarContent
                  width={width}
                  className='container'
                  initial='closed'
                  animate='open'
                  exit='closed'
                  transition={{ delay: 0.25 }}
                  variants={childrenVariants}
                >
                  {closeButtonVisible ? (
                    <SidebarCloseButton onClick={onDismiss}>
                      <FontAwesomeIcon icon={['far', 'close']} />
                    </SidebarCloseButton>
                  ) : null}
                  {children}
                </SidebarContent>
              </SidebarAside>
            </>
          )}
        </AnimatePresence>
      </SidebarContainer>
    </Portal>
  )
}
